<template>
  <v-app>
    <div id="body">
      <v-container>
        <v-row v-if="documento.tipoDocumento.legislacao" justify="center">
          <img src="estado.png" alt="Estado do MA" style="width: 100px; height: auto" />
        </v-row>
        <v-row v-else style="margin-left: 10px">
          <img src="logo_tce.png" alt="TCEMA" />
        </v-row>
        <div v-if="documento.tipoDocumento.legislacao">
          <v-row justify="center">
            <h3>ESTADO DO MARANHÃO</h3>
          </v-row>
          <v-row v-if="isNotLei()" justify="center">
            <h3>TRIBUNAL DE CONTAS DO ESTADO</h3>
          </v-row>
        </div>

        <v-row cols="12" v-if="documento.html">
          <v-col md="6">
            <v-btn id="idbtn" class="printButton" v-if="compilado" color="primary" small depressed
              @click="textoCompleto()">
              <v-icon small left>fa-file-alt</v-icon>Texto Completo
            </v-btn>

            <v-btn id="idbtn2" v-else class="printButton" color="primary" small depressed @click="textoCompilado()">
              <v-icon small left>fa-cog</v-icon>Texto Compilado
            </v-btn>

            <v-btn v-if="documento.diarioId" id="idbtn3" style="margin-left: 10px" class="printButton" color="primary"
              small depressed @click="abrirDiario()">
              <v-icon small left>fa-file-alt</v-icon>Diário Oficial
            </v-btn>
            <v-btn
              id="idbtn3"
              style="margin-left: 10px"
              class="printButton"
              color="primary"
              small
              depressed
              @click="imprimir()"
            >
              <v-icon small left>fa-print</v-icon>Exportar/Imprimir
            </v-btn>
          </v-col>
        </v-row>
        <hr />
        <br />
        <div id="divHtml" v-html="texto" :key="chave" />
      </v-container>
    </div>
  </v-app>
</template>

<script>
import documentoService from "@/service/DocumentoService";
import Documento from "@/model/documento.js";
export default {
  data() {
    return {
      chave: 0,
      compilado: false,
      texto: "",
      documento: Documento(),
    };
  },
  methods: {

    imprimir() {
      window.print();
    },
    textoCompilado() {
      document.querySelectorAll("s").forEach((x) => {
        x.remove();
      });

      document
        .querySelectorAll("span, p, td, i")
        .forEach(
          (el) => el.textContent.trim() === "" && el.parentNode.removeChild(el)
        );

      // document.querySelectorAll("br").forEach((x) => {
      //   x.remove();
      // });

      // var pVazio = document.getElementsByTagName("p");
      // for (let el of pVazio) {
      //   cleaner(el);
      // }

      // var options = document.getElementsByTagName("td");
      // var indexTd;
      // for (indexTd = 0; indexTd < options.length; ++indexTd) {
      //   options[indexTd].innerHTML = options[indexTd].innerHTML.replace(
      //     "&nbsp;",
      //     ""
      //   );
      // }
      // document.querySelectorAll("p:empty").forEach((x) => {
      //   x.remove();
      // });
      // document.querySelectorAll("td:empty").forEach((x) => {
      //   x.remove();
      // });
      // document.querySelectorAll("i:empty").forEach((x) => {
      //   x.remove();
      // });
      this.compilado = true;

      // function cleaner(el) {
      //   if (el.innerHTML == "&nbsp;" || el.innerHTML == "") {
      //     el.parentNode.removeChild(el);
      //     //el.remove();
      //   }
      // }
    },

    textoCompleto() {
      this.texto = this.documento.html;
      this.compilado = false;
      this.chave = this.chave + 1;
    },
    textoOriginal() {
      this.texto = this.documento.htmlOriginal;
    },
    isNotLei() {
      //não mostra o nome do TCE se for lei
      if (this.documento != null) {
        if (
          this.documento.tipoDocumento.tipoDocumentoId == 6 ||
          this.documento.tipoDocumento.tipoDocumentoId == 19
        ) {
          return false;
        }
      }
      return true;
    },
    abrirDiario() {
      if (this.documento.diarioId) {
        let diarioUrl = "https://diario.apps.tcema.tc.br/publicacao/pdf/";
        window.open(diarioUrl + this.documento.diarioId, "_blank");
      }
    },
  },

  updated() {
    if (this.compilado) {
      this.textoCompilado();
    }
  },
  created() {
    this.compilado = this.$route.query.compilado
      ? this.$route.query.compilado
      : false;

    documentoService.buscarDocumento(this.$route.params.id).then((result) => {
      if (!result) {
        // id inexistente ou API indisponível: o service devolve undefined
        this.$router.push("/notfound");
        return;
      }
      this.documento = result;
      if (this.documento.html) {
        this.texto = this.documento.html;
      } else {
        documentoService.downloadArquivo(this.documento.documentoId);
      }
    });
  },
};
</script>

<style>
#body {
  font-weight: 500;
}

div#divHtml p {
  margin-bottom: 20px;
}

div#divHtml table td,
div#divHtml table th {
  border: 1px solid #ddd;
  padding: 5px;
}

div#divHtml table {
  border-collapse: collapse;
}

#idbtn3 {
  color: black !important;
  background-color: white !important;
  border-color: #262626 !important;
  border-radius: 10px;
  border: solid 1px;
}

#idbtn2 {
  color: black !important;
  background-color: white !important;
  border-color: #262626 !important;
  border-radius: 10px;
  border: solid 1px;
}

#idbtn {
  color: black !important;
  background-color: white !important;
  border-color: #262626 !important;
  border-radius: 10px;
  border: solid 1px;
}

@media print {
  .printButton {
    display: none;
  }
}
</style>